/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/check_medium'
export default icon
